// src/admin/AdminLoginPage.js
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { signInWithEmailAndPassword, onAuthStateChanged } from "firebase/auth";
import { auth } from "../firebase";
import { useNavigate, Link } from "react-router-dom";

const Page = styled.main`
  min-height: 70vh;
  padding: 40px 18px;
  background: #f7fafc;
`;

const Box = styled.section`
  max-width: 520px;
  margin: 0 auto;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 18px;
  padding: 18px;
  box-shadow: 0 12px 34px rgba(0,0,0,0.06);
`;

const Form = styled.form`
  display: grid;
  gap: 12px;
`;

const Input = styled.input`
  padding: 12px 14px;
  border-radius: 14px;
  border: 1px solid #e5e7eb;
`;

const Btn = styled.button`
  border: 1px solid rgba(15,118,110,0.22);
  background: #0f766e;
  color: #fff;
  font-weight: 900;
  border-radius: 999px;
  padding: 12px 14px;
  cursor: pointer;
  &:disabled { opacity: 0.65; cursor: wait; }
`;

export default function AdminLoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (user) => {
      if (user) navigate("/admin", { replace: true });
    });
    return () => unsub();
  }, [navigate]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      await signInWithEmailAndPassword(auth, email.trim(), pw);
      // onAuthStateChanged skickar dig vidare när user finns
    } catch (e2) {
      const msg =
        e2?.code === "auth/invalid-credential"
          ? "Fel e-post eller lösenord."
          : e2?.code === "auth/too-many-requests"
          ? "För många försök. Vänta en stund och testa igen."
          : "Kunde inte logga in. Kontrollera uppgifterna.";
      setErr(msg);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Page>
      <Box>
        <h1>Admin • Logga in</h1>

        <Form onSubmit={onSubmit}>
          <Input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="E-post"
            required
          />
          <Input
            type="password"
            value={pw}
            onChange={(e) => setPw(e.target.value)}
            placeholder="Lösenord"
            required
          />

          {err ? <div style={{ color: "#e94e1b", fontWeight: 900 }}>{err}</div> : null}

          <Btn type="submit" disabled={busy}>
            {busy ? "Loggar in…" : "Logga in"}
          </Btn>

          <Link to="/">Tillbaka</Link>
        </Form>
      </Box>
    </Page>
  );
}

